module.exports = "../../app/cells/components/cms/render_component_cell.rb";